<template>
    <div class="clearfix">
        <vForm class="clearfix" v-model="formData" labelWidth="100">
            <vCol span="24">
                <vFormItem class="width-75per" :label="$t('fbb.headlogistics.length_unit', { defaultValue: '长度单位' })">
                    <vSelect v-model="formData.length" @on-change="changeUnit">
                        <vOption v-for="item in lengthList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem class="width-75per" :label="$t('fbb.headlogistics.weight_unit', { defaultValue: '重量单位' })">
                    <vSelect v-model="formData.weight" @on-change="changeUnit">
                        <vOption v-for="item in weightList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem class="width-75per" :label="$t('fbb.headlogistics.volumn_unit', { defaultValue: '体积单位' })">
                    <vSelect v-model="formData.volume" @on-change="changeUnit">
                        <vOption v-for="item in volumeList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
            </vCol>
        </vForm>
        <ButtonGroup class="pull-right">
            <vButton class="margin-15" theme="primary" @click="exportFile">{{$t('global.common.export', { defaultValue: '导出' })}}</vButton>
            <vButton class="margin-15" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
        </ButtonGroup>
        <div v-show="false">
            <table ref="exportTable" border="1" class="export-table">
                <tr>
                    <th colspan="15">Shipment Information-THE BIZARK</th>
                </tr>
                <tr>
                    <th colspan="2">头程单号：</th>
                    <th colspan="7">{{orderData.preLogisticsNo}}</th>
                    <th colspan="6">Remark</th>
                </tr>
                <tbody v-for="item in orderData.logisticsContactRequests" :key="item.key">
                    <tr>
                        <td colspan="2" style="text-align:center;">
                            <div>工厂联系方式-</div>
                            <div>{{item.factoryName}}</div>
                        </td>
                        <td colspan="7">
                            <div>工厂名称: {{item.factoryName}}</div>
                            <div>工厂详细地址: {{item.factoryAddress}}</div>
                            <div>联系人： {{item.factoryContact}}</div>
                            <div>联系电话： {{item.factoryPhone}}</div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="2" style="text-align:center;">
                            <div>发货方联系方式-</div>
                            <div>{{item.senderName}}</div>
                        </td>
                        <td colspan="7">
                            <div>发货方公司名称: {{item.senderName}}</div>
                            <div>发货方详细地址: {{item.senderAddress}}</div>
                            <div>发货人： {{item.senderContact}}</div>
                            <div>联系电话： {{item.senderPhone}}</div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
                <tr>
                    <th colspan="2">出口报关</th>
                    <td>□工厂</td>
                    <td style="background-color: yellow;">□货代</td>
                    <th>提货方式</th>
                    <td>□工厂送货</td>
                    <td>□货代自提</td>
                    <th>提货地</th>
                    <td></td>
                    <td colspan="6"></td>
                </tr>
                <tr rowspan="4">
                    <td colspan="2" style="text-align:center;">
                        <div>进口商联系方式-</div>
                        <div>{{orderData.receiverCompanyName}}</div>
                    </td>
                    <td colspan="7">
                        <div>进口商公司名称：{{orderData.receiverCompanyName}}</div>
                        <div>进口商详细地址: {{orderData.receiverAddress}}</div>
                        <div>联系人：{{orderData.receiverContact}}</div>
                        <div>联系电话：{{orderData.receiverPhone}}</div>
                        <div>固定电话：{{orderData.receiverTelephone}}</div>
                        <div>传真：{{orderData.receiverFax}}</div>
                        <div>其他联系方式：{{orderData.receiverNote}}</div>
                    </td>
                    <td colspan="6"></td>
                </tr>
                <tr>
                    <td colspan="2" style="text-align:center;">
                        <div>Bound</div>
                    </td>
                    <td colspan="7">
                        <div>{{orderData.bound}}</div>
                    </td>
                    <td colspan="6"></td>
                </tr>
                <tr>
                    <th colspan="2">运输方式</th>
                    <td v-for="item in transportList" :key="item.key" :style="orderData.transportType === item.value ? 'background-color: yellow;' : ''">□{{item.label}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td colspan="6"></td>
                </tr>
                <tr>
                    <td>预计装柜日期</td>
                    <td>{{orderData.expectStuffingDate}}</td>
                    <td>起运港口</td>
                    <th>{{orderData.shipPort}}</th>
                    <td>目的国</td>
                    <td>US</td>
                    <td>最终送达地址</td>
                    <td :style="singleAddress ? 'background-color: yellow;' : ''">□Single（单个）</td>
                    <td :style="singleAddress ? '' : 'background-color: yellow;'">□Multiple（多个）</td>
                    <td colspan="6"></td>
                </tr>
                <tbody v-for="item in orderData.subLogisticsHeadParams" :key="item.key">
                    <tr style="background-color: lightskyblue;">
                        <td colspan="2">最终送达地址1(Delivery address1)</td>
                        <td colspan="13">{{item.addressEntity.address || ''}},{{item.addressEntity.city|| ''}},{{item.addressEntity.state|| ''}},{{item.addressEntity.country|| ''}},{{item.addressEntity.linkman|| ''}},{{item.addressEntity.phone|| ''}}</td>
                    </tr>
                    <tr style="bakcground-color: grey;">
                        <th colspan="15">Cargo Information</th>
                    </tr>
                    <tr>
                        <th>序号</th>
                        <th>报关品名（中文）</th>
                        <th>报关品名（英文）</th>
                        <th>目的国HS Code</th>
                        <th>ERPSKU</th>
                        <th>装箱入数</th>
                        <th>L({{formData.length}})</th>
                        <th>W({{formData.length}})</th>
                        <th>H({{formData.length}})</th>
                        <th>Weight({{formData.weight}})单箱重量</th>
                        <th>Volume({{formData.volume}})单箱体积</th>
                        <th>箱数</th>
                        <th>Total Weight({{formData.weight}})总重量</th>
                        <th>Total Volume(cbm)总体积</th>
                        <th>Remark备注</th>
                    </tr>
                    <tr v-for="(goods, index) in item.logisticsDetailEntities" :key="goods.key">
                        <td>{{index + 1}}</td>
                        <td>{{goods.name}}</td>
                        <td>{{goods.nameEn}}</td>
                        <td>{{goods.hscode}}</td>
                        <td>{{goods.sku}}</td>
                        <td>{{goods.quantity}}</td>
                        <td>{{goods.length}}</td>
                        <td>{{goods.width}}</td>
                        <td>{{goods.height}}</td>
                        <td>{{goods.weight}}</td>
                        <td>{{goods.volume}}</td>
                        <td>{{goods.boxQty}}</td>
                        <td>{{goods.weightTotal}}</td>
                        <td>{{goods.volumeTotal}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <th colspan="11">(Delivery address1) GRAND TOTAL</th>
                        <th>总箱数：{{item.totalQuantity}}箱</th>
                        <th>总重量：{{item.totalWeight}}{{formData.weight}}</th>
                        <th>总体积：{{item.totalVolume}}{{formData.volume}}</th>
                        <th></th>
                    </tr>
                    <tr>
                        <th colspan="7">发亚马逊仓需填写</th>
                        <th>Shipment ID</th>
                        <th colspan="2">{{item.shipmentId}}</th>
                        <th>Referenc ID</th>
                        <th>{{item.referenceId}}</th>
                        <th>建仓时间</th>
                        <th colspan="2"></th>
                    </tr>
                </tbody>
                <tr style="background-color: yellow;">
                    <th colspan="11">GRAND TOTAL</th>
                    <th>总箱数：{{formData.totalQuantity}}箱</th>
                    <th>总重量：{{formData.totalWeight}}{{formData.weight}}</th>
                    <th>总体积：{{formData.totalVolume}}{{formData.volume}}</th>
                    <th></th>
                </tr>
                <tr>
                    <th colspan="15" style="color: red;">Special Handling instruction:</th>
                </tr>
                <tr>
                    <th colspan="15"></th>
                </tr>
                <tr>
                    <td>重要提醒</td>
                    <th colspan="6" style="font-weight: bold; color: red;">请填写订舱单后务必核实信息准确，特别是收件地址和亚马逊ID请再三核实无误</th>
                    <th>制表人</th>
                    <th colspan="7"></th>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import mixinlist from './../mixin'
export default {
    mixins: [mixinlist],
    props: ['originData'],
    computed: {
        getUnit (value, originUnit, targetUnit) {
            return (value, originUnit, targetUnit) => {
                return this.handleUnit(value, originUnit, targetUnit)
            }
        },
    },
    data () {
        return {
            orderData: {},
            defaultUnit: {
                length: 'cm',
                weight: 'kg',
                volume: 'cbm'
            },
            formData: {
                length: 'cm',
                weight: 'kg',
                volume: 'cbm',
                totalWeight: 0,
                totalQuantity: 0,
                totalVolume: 0
            },
            lengthList: [{
                value: 'cm',
                label: 'cm'
            }, {
                value: 'inch',
                label: 'inch'
            }],
            weightList: [{
                value: 'kg',
                label: 'kg'
            }, {
                value: 'lbs',
                label: 'lbs'
            }],
            volumeList: [{
                value: 'cbm',
                label: 'cbm'
            }],
            singleAddress: false
        }
    },
    created () {
        this.orderData = this.originData
        if (this.originData.subLogisticsHeadParams.length > 1) {
            this.singleAddress = false
        }
        else {
            this.singleAddress = true
        }
        this.getTotal()
    },
    methods: {
        changeUnit () {
            this.orderData.subLogisticsHeadParams = this.orderData.subLogisticsHeadParams.map(item => {
                return {
                    ...item,
                    totalWeight: parseFloat(this.handleUnit(item.totalWeight, this.defaultUnit.weight, this.formData.weight, 4)),
                    totalVolume: parseFloat(this.handleUnit(item.totalVolume, this.defaultUnit.volume, this.formData.volume, 4)),
                    logisticsDetailEntities: item.logisticsDetailEntities.map(childItem => { 
                        let originWeightUnit = childItem.weightUnit,
                            originVolumeUnit = childItem.volumeUnit,
                            originLengthUnit = childItem.lengthUnit
                        return {
                            ...childItem,
                            width: this.handleUnit(childItem.width, originLengthUnit, this.formData.length, 4),
                            length: this.handleUnit(childItem.length, originLengthUnit, this.formData.length, 4),
                            height: this.handleUnit(childItem.height, originLengthUnit, this.formData.length, 4),
                            weight: this.handleUnit(childItem.weight, originWeightUnit, this.formData.weight, 4),
                            volume: this.handleUnit(childItem.volume, originVolumeUnit, this.formData.volume, 4),
                            weightTotal: this.handleUnit(childItem.weightTotal, originWeightUnit, this.formData.weight, 4),
                            volumeTotal: this.handleUnit(childItem.volumeTotal, originVolumeUnit, this.formData.volume, 4),
                            weightUnit: this.formData.weight,
                            volumeUnit: this.formData.volume,
                            lengthUnit: this.formData.length
                        }
                    })
                }
            })
            this.defaultUnit.length = this.formData.length
            this.defaultUnit.weight = this.formData.weight
            this.defaultUnit.volume = this.formData.volume
            this.getTotal()
            this.$forceUpdate()
        },
        /**
         * 小数加法计算,略微损失精度
         * @param {number} value1 加数1
         * @param {number} value2 加数2
         */
        floatPlus (value1, value2) {
            let l1 = parseInt(value1).toString().length,
                l2 = value1.toString().length,
                l3 = parseInt(value2).toString().length,
                l4 = value2.toString().length
            // int
            if (l1 === l2 && l3 === l4) {
                return value1 + value2
            }
            let length1 = l2 - l1 - 1,
                length2 = l4 - l3 - 1
            let needLength = length1
            if (length1 < length2) {
                needLength = length2
            }

            // float
            let n1 = Math.round(value1 * Math.pow(10, needLength)),
                n2 = Math.round(value2 * Math.pow(10, needLength))
            return (n1 + n2) / Math.pow(10, needLength)
        },
        getTotal () {
            let totalWeight = 0,
                totalQuantity = 0,
                totalVolume = 0
            this.orderData.subLogisticsHeadParams.map(item => {
                // totalWeight += parseFloat(item.totalWeight)
                totalWeight = this.floatPlus(totalWeight, parseFloat(item.totalWeight))
                // totalQuantity += parseFloat(item.totalQuantity)
                totalQuantity = this.floatPlus(totalQuantity, parseFloat(item.totalQuantity))
                // totalVolume += parseFloat(item.totalVolume)
                totalVolume = this.floatPlus(totalVolume, parseFloat(item.totalVolume))
            })
            this.formData = {
                ...this.formData,
                totalWeight,
                totalVolume,
                totalQuantity
            }
        },
        exportFile () {
            let html = 
            `<html>
                <head>
                <meta charset='utf-8' />
                </head>
                <body>${this.$refs.exportTable.outerHTML}</body>
            </html>
            `
            let blob = new Blob([html], { type: 'application/vnd.ms-excel' })
            let url = URL.createObjectURL(blob)
            let btnA = document.createElement('a')
            btnA.href = url
            btnA.download = `${this.orderData.projectName}-订舱单-${this.orderData.preLogisticsNo}-${this.formData.totalQuantity}箱.xls`
            btnA.click()
            URL.revokeObjectURL(btnA.href)
            this.cancel()
        },
        cancel () {
            this.$emit('on-close')
        }
    }
}
</script>

<style lang="scss" scoped>
    .export-table {
        width: 100%;
        border-collapse: collapse;
    }
</style>